<div class="iis-card" [class.iis-disabled]="disabled">
  <!-- Cabecalho -->
  <div class="iis-header">
    <div class="iis-title-block">
      <i class="pi pi-images iis-title-icon"></i>
      <div class="iis-title-text">
        <span class="iis-title">{{ 'item_imagens_secundarias.titulo' | translate }}</span>
        <small class="iis-subtitle">{{ 'item_imagens_secundarias.subtitulo' | translate }}</small>
      </div>
    </div>
    <span class="iis-counter">{{ textoContador() }}</span>
  </div>

  <!-- Bloqueio item de sistema (disabled) -->
  <div *ngIf="disabled" class="iis-bloqueado">
    <i class="pi pi-lock"></i>
    <span>{{ 'item_imagens_secundarias.bloqueado_item_sistema' | translate }}</span>
  </div>

  <!-- Estado: carregando inicial -->
  <div *ngIf="carregando" class="iis-grid">
    <p-skeleton *ngFor="let _ of [0,1,2,3]" width="100%" height="120px" styleClass="iis-skeleton"></p-skeleton>
  </div>

  <!-- Estado: erro de carregamento -->
  <div *ngIf="!carregando && erroCarregamento" class="iis-erro-carregamento">
    <i class="pi pi-exclamation-triangle"></i>
    <span>{{ 'item_imagens_secundarias.erros.erro_carregar_galeria' | translate }}</span>
    <button pButton type="button" class="p-button-sm p-button-text" icon="pi pi-refresh"
      (click)="carregarImagens()"></button>
  </div>

  <!-- Estado: vazio -->
  <div *ngIf="!carregando && !erroCarregamento && imagens.length === 0 && !enviando" class="iis-vazio">
    <i class="pi pi-image"></i>
    <span>{{ 'item_imagens_secundarias.estado_vazio' | translate }}</span>
  </div>

  <!-- Estado: enviando -->
  <div *ngIf="enviando" class="iis-enviando">
    <p-progressSpinner styleClass="iis-spinner" strokeWidth="3"></p-progressSpinner>
    <span *ngIf="progressoEnvio">
      {{ 'item_imagens_secundarias.enviando_progresso' | translate:{ atual: progressoEnvio.atual, total: progressoEnvio.total } }}
    </span>
    <span *ngIf="!progressoEnvio">{{ 'item_imagens_secundarias.enviando' | translate }}</span>
  </div>

  <!-- Galeria de imagens existentes -->
  <div *ngIf="!carregando && !erroCarregamento && imagens.length > 0" class="iis-grid">
    <div *ngFor="let img of imagens; let i = index" class="iis-thumb"
      [pTooltip]="'item_imagens_secundarias.tooltip_expandir' | translate" tooltipPosition="top"
      (click)="abrirLightbox(img, i)" (keydown.enter)="abrirLightbox(img, i)"
      role="button" tabindex="0">
      <img [src]="urlDaImagem(img)" [alt]="altDaImagem(i)" loading="lazy" />

      <!-- Botao de remocao individual -->
      <button *ngIf="!disabled" type="button" class="iis-thumb-remove"
        [disabled]="enviando || removendoId !== null"
        [pTooltip]="'item_imagens_secundarias.tooltip_remover' | translate" tooltipPosition="top"
        [attr.aria-label]="'item_imagens_secundarias.tooltip_remover' | translate"
        (click)="removerImagem(img, $event)"
        (keydown.enter)="removerImagem(img, $event)">
        <i class="pi" [ngClass]="removendoId === img.id ? 'pi-spin pi-spinner' : 'pi-times'"></i>
      </button>
    </div>
  </div>

  <!-- Botao de upload -->
  <div *ngIf="podeAdicionarMais()" class="iis-upload">
    <p-fileUpload #fileUploader
      name="imagensSecundarias"
      [multiple]="true"
      accept="image/jpeg,image/jpg,image/png,image/gif"
      [maxFileSize]="TAMANHO_MAX_BYTES"
      [auto]="true"
      [customUpload]="true"
      [showUploadButton]="false"
      [showCancelButton]="false"
      [disabled]="disabled || enviando"
      [chooseLabel]="'item_imagens_secundarias.botao_adicionar' | translate"
      chooseIcon="pi pi-plus"
      (uploadHandler)="onSelectArquivos($event)">
    </p-fileUpload>
  </div>
</div>

<!-- Lightbox embutido -->
<div *ngIf="lightboxAberto" class="iis-lightbox-overlay" role="dialog" aria-modal="true"
  (click)="fecharLightbox()" (keydown.escape)="fecharLightbox()">
  <button pButton type="button" class="p-button-rounded p-button-text iis-lightbox-close"
    icon="pi pi-times" [attr.aria-label]="'item_imagens_secundarias.tooltip_expandir' | translate"
    (click)="fecharLightbox(); $event.stopPropagation()"></button>
  <img *ngIf="lightboxUrl" [src]="lightboxUrl" [alt]="lightboxAlt"
    class="iis-lightbox-img" (click)="$event.stopPropagation()" />
</div>
